import { type Placement } from "@floating-ui/react";
import {
  DateRangeChoiceEnum,
  type DateRangeChoiceV2,
  type FixedDateInterval,
} from "@north-beam/nb-common";
import { DateRangeDisplay, DateRangePicker } from "@shared/date-range-picker";

interface DateRangeSelectProps {
  isLoading: boolean;
  dateRange: FixedDateInterval | DateRangeChoiceV2;
  maxLookbackDays?: number;
  showDateRangeDisplay?: boolean;
  className?: string;
  popoverClassName?: string;
  popoverPlacement?: Placement;
  onUpdate: (opt: FixedDateInterval | DateRangeChoiceV2) => void;
}

export function DateRangeSelect({
  isLoading,
  dateRange,
  onUpdate,
  maxLookbackDays,
  showDateRangeDisplay = true,
  className,
  popoverClassName,
  popoverPlacement,
}: DateRangeSelectProps) {
  return (
    <div className={className}>
      <DateRangePicker
        label="DATE RANGE"
        disabled={isLoading}
        nonCustomChoices={DateRangeChoiceEnum.reactSelectOptions}
        dateRange={dateRange}
        onUpdate={onUpdate}
        maxLookbackDays={maxLookbackDays}
        popoverClassName={popoverClassName}
        popoverPlacement={popoverPlacement}
      />
      {showDateRangeDisplay && (
        <div className="mt-0.5 text-xs font-light">
          <DateRangeDisplay
            dateRange={dateRange}
            onConversionToFixed={onUpdate}
          />
        </div>
      )}
    </div>
  );
}
